// material ui
import { MenuItem, IconButton, Menu, Typography, Box, Stack, Divider, Tooltip, Alert, Icon, Link } from "@mui/material"

import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
//slices
import { getMensagensWhatsappDb } from 'src/redux/slices/chat'
//utils
import { soNumeros, verifyRules } from '../../../../../../utils/functions';
import { AlertDialogLoading } from "../AlertDialogLoading";
import AudioComponent from "../AudioComponent";
import LocationPreview from "../LocationPreview";
import MarkdownWrapper from './MarkdownWrapper';
import { QuotedMessage } from "./QuotedMessage";
import {
  ChatLayout,
  ImageContainer,
  ImageContainerReply,
  MessageContent,
  MessageContentText,
} from "./style";
import useAuth from "src/hooks/useAuth";
import { downloadFromBase64 } from "src/utils/helpers";
import Iconify from "src/components/Iconify";
import { useSnackbar } from "notistack";
import SkeletonChatImage from "src/components/skeleton/chats/SkeletonChatImage";
import moment from "moment";
const defaultImage = "https://zapchat.nyc3.digitaloceanspaces.com/images/not-picture.png";

import { Button } from "src/@/components/ui/button";
import { Progress } from "src/@/components/ui/progress";

//actions
import v1_actionDownloadMediaWhatsapp from "src/actions/v1/whatsapp/v1_actionDownloadMediaWhatsapp";
import v1_actionDeletarMensagemWhatsapp from "src/actions/v1/whatsapp/v1_actionDeletarMensagemWhatsapp";
import v1_actionEncaminharMensagemWhatsapp from "src/actions/v1/whatsapp/v1_actionEncaminharMensagemWhatsapp";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "src/@/components/ui/dropdown-menu"
import Scrollbar from "src/components/Scrollbar";
import { ZuiTooltip } from "src/@/components/use/tooltip";
import { base64ToBlob, getImageBlob, initCacheFileSave } from "src/helpers/cache.helper";
import ModalMultiContact from "src/components/_chats/ModalMultiContact";
import Vcard from "src/components/_chats/Vcard";
import { Card, CardContent } from "src/@/components/ui/card";
import { ButtonLoading } from "src/@/components/use/ButtonLoading";
import { Badge } from "src/@/components/ui/badge";
import { getAudioFromCache } from 'src/helpers/audio.helper';
import ModalEncaminharMsg from "src/sections/@chats/chat/ChatComponent/ModalEncaminharMsg";
import TemplateMessage from "./TemplateMessage";
const mimeTypesImages = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/webp"];

const ChatComponent = ({
  message,
  config,
  chat,
  isMe,
  isWarning,
  selectMessageId,
  selectMessageResponder,
  callbackGpt,
  isDesktop,
  key,
  onCallbakOpenModal,
  onDeleteNote,
  isReply,
  resendMsg,
  onResendAudio,
  onDeleteMsgAudioResend,
  loadingResend,
  loadingResendAudio
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { user, cliente } = useAuth()
  const { t } = useTranslation('chat');
  const imageRef = useRef(null);
  const audioRef = useRef(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [display, setDisplay] = useState("block");
  const [openModalImage, setOpenModalImage] = useState(false);
  const textRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openEncaminharDialog, setOpenEncaminharDialog] = useState(false);
  const [loadingDeletarMensagem, setLoadingDeletarMensagem] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingDownloadVideo, setLoadingDownloadVideo] = useState(false);
  const [loadingDownloadVideoId, setLoadingDownloadVideoId] = useState(null);
  const [isDownloadImage, setIsDownloadImage] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const typesIgnore = ["notification_template", "e2e_notification", "call_log", "gp2"];
  const [openMenu, setOpenMenuActions] = useState(null);
  const [loadingEncaminharMensagem, setLoadingEncaminharMensagem] = useState(null);
  const [blobUrl, setBlobUrl] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [progressValue, setProgressValue] = useState(0);

  const platform = message.platform || 'whatsapp';




  const handleResendClick = () => {
    if (isButtonDisabled) return;

    setIsButtonDisabled(true);
    if (message.type === 'ptt' || message.type === 'audio') {
      onResendAudio(message.id);
    } else {
      resendMsg(message);
    }

    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 1000); // 1 segundo de debounce
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function validaChatId(val) {
    if (typeof val.chatId === 'string') {
      return soNumeros(val.chatId);
    } else {
      return val.chatId.user;
    }
  }

  const getCacheBlob = async (id, message) => {
    const response = await getImageBlob(id);
    if (!response) return;
    if (message.type === "image") {
      setBlobUrl(response)
    } else if (message.type === "audio" || message.type === "ptt") {
      setAudioUrl(response)
      setDownloaded(true);
    } else if (message.type === "video") {
      setBlobUrl(response)
      setDownloaded(true);
    }

  }

  useEffect(() => {
    if (blobUrl) return;
    getCacheBlob(message.id, message);
  }, [])

  // Animação do progresso para componentes de loading
  useEffect(() => {
    if (message.preSend || (loadingDownloadVideo && message.id === loadingDownloadVideoId)) {
      const interval = setInterval(() => {
        setProgressValue(prev => {
          if (prev >= 90) return prev;
          return prev + Math.random() * 15;
        });
      }, 500);

      return () => clearInterval(interval);
    } else {
      setProgressValue(0);
    }
  }, [message.preSend, loadingDownloadVideo, loadingDownloadVideoId, message.id]);

  const excluirMensagem = async (message) => {
    try {
      const querys = `?sessao=${chat.sessao}&canal=${chat?.canal}`;
      let data = { phone: validaChatId(message), messageId: message.id }
      await v1_actionDeletarMensagemWhatsapp(querys, data)
      dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
    } catch (error) {
      console.log('Erro ao apagar mensagem do Chat', error)
    }
  };

  async function encaminharMesagemWhatsapp(phone) {
    try {
      setLoadingEncaminharMensagem(true);
      let data = {
        phone: phone,
        messageId: message.id
      };
      const querys = `?sessao=${chat.sessao}&canal=${plataform}`;
      await v1_actionEncaminharMensagemWhatsapp(querys, data);
      setLoadingEncaminharMensagem(false);
      setOpenEncaminharDialog(false)

      enqueueSnackbar(t('forward.success'), { variant: 'success' });

    } catch (error) {
      enqueueSnackbar(t('forward.error'), { variant: 'error' });
      setLoadingEncaminharMensagem(false);
      console.log(error);
    }
  }

  async function baixarMidiaDevice() {
    let querys = `?sessao=${chat.sessao}&msgId=${message.id}&canal=${platform}`
    const response = await v1_actionDownloadMediaWhatsapp(querys);
    const a = document.createElement("a");
    a.href = `data:${message.mimetype};base64, ${response.data.data.base64}`;
    a.download = `lais_file-${moment(new Date()).format("YYYY-MM-DD:HH:mm")}`;
    a.click();
    ///downloadFromBase64(response.data.data.base64, `lais_${(new Date).toISOString()}`, validaAudio())
  }

  async function baixarAudioDevice() {
    function validaAudio() {
      if (message.type === "audio" || message.type === "ptt") {
        return 'audio/mp3';
      } else {
        return message.mimetype;
      }
    }
    let querys = `?sessao=${chat.sessao}&msgId=${message.id}&canal=${platform}`
    const response = await v1_actionDownloadMediaWhatsapp(querys);
    downloadFromBase64(response.data.data.base64, `lais_file-${moment(new Date()).format("YYYY-MM-DD:HH:mm")}`, validaAudio())
  }


  const onClickDownload = async (type, option) => {
    const checkBlob = await getImageBlob(message.id);
    if (checkBlob) {
      if (type === "image") {
        imageRef.current.src = checkBlob;
        setIsDownloadImage(true);
        setDisplay("none");
      } else if (type === "audio") {
        setAudioUrl(checkBlob);
      }
      return true;
    }
    try {
      setLoadingDownload(true)

      if (type === "video") {
        setLoadingDownloadVideo(true)
        setLoadingDownloadVideoId(message.id)
      }
      let querys = `?sessao=${chat.sessao}&msgId=${message.id}&canal=${platform}`
      const response = await v1_actionDownloadMediaWhatsapp(querys);
      if (type === "video" && response.data.status === "error") {
        setLoadingDownloadVideo(false)
        setLoadingDownloadVideoId(null);
        enqueueSnackbar(t('messageList.mediaDownloadFailed'), { variant: 'error' });
      }
      setLoadingDownloadVideo(false)
      setLoadingDownloadVideoId(null)
      setLoadingDownload(false)

      if (type === "image") {
        initCacheFileSave(message.id, `data:image/jpeg;base64, ${response.data.data.base64}`, message.mimetype);
        console.log('cache salvo', message.id, `data:image/jpeg;base64, ${response.data.data.base64}`, message.mimetype)
        imageRef.current.src = `data:image/jpeg;base64, ${response.data.data.base64}`;
        setIsDownloadImage(true);
        setDisplay("none");
        setLoadingDownload(false)
      } else if (type === "video") {
        initCacheFileSave(message.id, `data:video/webm;base64, ${response.data.data.base64}`, message.mimetype);

        imageRef.current.src = `data:video/webm;base64, ${response.data.data.base64}`;
        setDisplay("none");
        setDownloaded(true);
      } else if (type === "ptt") {
        initCacheFileSave(message.id, `data:audio/ogg;base64, ${response.data.data.base64}`, message.mimetype);
        setAudioUrl(`data:audio/ogg;base64, ${response.data.data.base64}`);
        setDownloaded(true);
      } else if (type === "audio") {
        initCacheFileSave(message.id, `data:audio/ogg;base64, ${response.data.data.base64}`, message.mimetype);
        setDownloaded(true);
        setAudioUrl(`data:audio/ogg;base64, ${response.data.data.base64}`);
      } else if (type === "document") {
        const a = document.createElement("a");
        a.href = `data:${option.mimetype};base64, ${response.data.data.base64}`;
        a.download = `${option.filename}`;
        a.click();
      }
      return true;
    } catch (error) {
      console.log('erro ao baixar mídia', error)

      setLoadingDownloadVideo(null)
      setLoadingDownloadVideoId(false);
      setLoadingDownload(false)
      enqueueSnackbar(t('messageList.downloadFailed'), { variant: 'error' });
    }
  };


  const handleOnOpenModalImage = async () => {
    if (isDownloadImage) {
      onCallbakOpenModal(imageRef.current.src);
    } else {
      const response_download = await onClickDownload("image");
      if (response_download) onCallbakOpenModal(imageRef.current.src);

    }
  };


  function getMessageTime(m) {
    const date = new Date(m.timestamp * 1000);
    const lang = navigator.language || navigator.languages[0];
    const date_locale = date.toLocaleDateString(lang, {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    });
    const time_locale = date.toLocaleTimeString(lang);
    const formatted = `${date_locale} ${time_locale}`;
    return (
      <div style={{ marginTop: 5 }}>
        <small>
          <Stack spacing={1} direction="row">
            <Typography sx={{ fontSize: 10 }}>{formatted}</Typography>
            {isMe && (
              <Stack justifyContent={"center"} alignItems={"center"} direction={"row"} spacing={0.5}>
                {/* {m.ack == 0 && <Iconify icon="fluent:send-clock-20-filled" />} */}
                {m.preSend && <div className="w-2 h-2 bg-primary rounded-full animate-spin border-2 border-primary/20"></div>}
                {m.ack === -1 && <Iconify className="text-red-500" icon="ix:error-filled" />}
                {m.ack === 2 && <Iconify icon="ri:check-double-fill" />}
                {m.self === "out" && m.ack == 1 && <Iconify icon="material-symbols:check" />}
                {m.ack === 3 && <Iconify color="#1919FF" icon="ri:check-double-fill" />}
                {m.ack === 4 && <Iconify color="#1919FF" icon="ri:check-double-fill" />}
              </Stack>
            )}
          </Stack>

        </small>
      </div>
    );
  }

  function getSenderDisplayName() {
    const sender = message?.sender;
    return (
      sender?.formattedName ||
      sender?.pushName ||
      sender?.name ||
      sender?.verifiedName ||
      chat?.nomeCliente ||
      ''
    );
  }

  function getSender(m) {
    let sender = m?.sender?.id?.user;
    if (m.sender) {
      const key = [
        "name",
        "shortName",
        "pushname",
        "verifiedName",
        "formattedName",
      ].find((n) => {
        if (n in m.sender && !!String(m.sender[n]).trim()) {
          return m.sender[n];
        }
      });
      sender = m.sender[key];
    }
    return sender;
  }

  function getReason(m) {
    try {
      const sender = getSender(m);
      if (m.type === "sticker") return t('messageList.senderSentSticker', { sender });
      // if (m.type === "location") return `${sender} enviou uma localização`;
      if (m.type === "revoked") return t('messageList.senderDeletedMessage', { sender });
      if (m.type === "gp2") {
        let users = [];
        if (m.recipients && Array.isArray(m.recipients)) {
          users = m.recipients.reduce(
            (c, acc, i) => c + (i > 0 ? ", " : "") + acc.user,
            ""
          );
        }
        if (m.subtype === "leave") return t('messageList.userLeft', { user: m?.recipients[0]?.user });
        if (m.subtype === "remove") return t('messageList.senderRemoved', { sender, users });
        if (m.subtype === "add") return t('messageList.senderAdded', { sender, users });
      }
    } catch (error) {
      return <p>{t('common:status.error')}</p>;
    }
  }



  const validaMediaMessage = (message) => {

    if (message.type === 'location') {
      return (
        <LocationPreview
          base64={`data:image/jpg;base64, ${message.body}`}
          link={`https://www.google.com/maps/place/${message.lat},${message.lng}`}
        />
      )
    }

    if (message.type === "ptt") {
      if (message.preSend) {
        return (
          <div className="w-[200px] h-[100px] flex items-center justify-center bg-muted/20 rounded-lg border border-border/50 backdrop-blur-sm">
            <div className="flex flex-col items-center space-y-3">
              <div className="flex items-center space-x-2">
                <Iconify icon="solar:soundwave-bold" className="w-4 h-4 text-primary animate-pulse" />
                <p className="text-xs italic text-muted-foreground">{t('media.sendingAudio')}</p>
              </div>
              <div className="w-32">
                <Progress value={progressValue} className="h-2" />
              </div>
            </div>
          </div>
        )
      } else if (message.type === "revoked") {
        return (
          <Box>
            <Typography sx={{ mb: 2, fontSize: 12, fontStyle: 'italic' }}>{t('media.voiceDeleted')}</Typography>
          </Box>
        )
      } else {
        return (
          <div className="w-[270px]">
            <AudioComponent
              downloaded={downloaded}
              url={audioUrl}
              loading={loadingDownload}
              isMe={message.fromMe}
              profileImage={!message?.sender?.profilePicThumbObj?.eurl ? defaultImage : message?.sender?.profilePicThumbObj?.eurl}
              audioRef={audioRef}
              downloadAudio={onClickDownload}
              id={message.id}
            />

            {!message?.transcribeAudio ? (
              <></>
              // <Button 
              //   onClick={() => {
              //     // TODO: Implementar lógica de transcrição
              //     console.log("Transcrever áudio", message.id);
              //   }}
              //   variant="ghost" 
              //   className="w-full mt-2 text-xs flex items-center gap-2 text-violet-600 hover:text-violet-800"
              // >
              //   <Iconify icon="solar:document-text-linear" />
              //   Transcrever áudio
              // </Button>
            ) : (
              <p className="text-[12px] italic mt-4">{message?.transcribeAudio}</p>
            )}
          </div>

        )
      }



    } else if (message.type === "audio") {
      if (message.preSend) {
        return (
          <div className="w-[200px] h-[100px] flex items-center justify-center bg-muted/20 rounded-lg border border-border/50 backdrop-blur-sm">
            <div className="flex flex-col items-center space-y-3">
              <div className="flex items-center space-x-2">
                <Iconify icon="solar:soundwave-bold" className="w-4 h-4 text-primary animate-pulse" />
                <p className="text-xs italic text-muted-foreground">{t('media.sendingAudio')}</p>
              </div>
              <div className="w-32">
                <Progress value={progressValue} className="h-2" />
              </div>
            </div>
          </div>
        )
      } else if (message.type === "revoked") {
        return (
          <Box>
            <Typography sx={{ mb: 2, fontSize: 12, fontStyle: 'italic' }}>{t('media.audioDeleted')}</Typography>
          </Box>
        )
      } else {
        return (
          <div className="w-[270px]">
            <AudioComponent
              downloaded={downloaded}
              url={audioUrl}
              loading={loadingDownload}
              isMe={message.fromMe}
              profileImage={!message?.sender?.profilePicThumbObj?.eurl ? defaultImage : message?.sender?.profilePicThumbObj?.eurl}
              audioRef={audioRef}
              downloadAudio={onClickDownload}
              id={message.id}
            />

            {!message?.transcribeAudio ? (
              <></>

              // <Button 
              //   onClick={() => {
              //     // TODO: Implementar lógica de transcrição
              //     console.log("Transcrever áudio", message.id);
              //   }}
              //   variant="ghost" 
              //   className="w-full mt-2 text-xs flex items-center gap-2 text-violet-600 hover:text-violet-800"
              // >
              //   <Iconify icon="solar:document-text-linear" />
              //   Transcrever áudio
              // </Button>
            ) : (
              <p className="text-[12px] italic mt-4">{message?.transcribeAudio}</p>
            )}

          </div>

        )
      }


    } else if (message.type === "video") {
      if (message.preSend) {
        return (
          <div className="w-[200px] h-[200px] flex items-center justify-center bg-muted/20 rounded-lg border border-border/50 backdrop-blur-sm">
            <div className="flex flex-col items-center space-y-3">
              <div className="flex items-center space-x-2">
                <Iconify icon="solar:video-library-bold" className="w-4 h-4 text-primary animate-pulse" />
                <p className="text-xs italic text-muted-foreground">{t('media.sendingVideo')}</p>
              </div>
              <div className="w-32">
                <Progress value={progressValue} className="h-2" />
              </div>
            </div>
          </div>
        )
      } else if (loadingDownloadVideo && message.id === loadingDownloadVideoId) {
        return (
          <div className="w-[200px] h-[200px] flex items-center justify-center bg-muted/20 rounded-lg border border-border/50 backdrop-blur-sm">
            <div className="flex flex-col items-center space-y-3">
              <div className="flex items-center space-x-2">
                <Iconify icon="solar:download-bold" className="w-4 h-4 text-primary animate-pulse" />
                <p className="text-xs italic text-muted-foreground">{t('media.downloadingVideo')}</p>
              </div>
              <div className="w-32">
                <Progress value={progressValue} className="h-2" />
              </div>
            </div>
          </div>
        )
      } else {
        if (message.type === "revoked") {
          return (
            <Box>
              <Typography sx={{ mb: 2, fontSize: 12, fontStyle: 'italic' }}>{t('media.videoDeleted')}</Typography>
            </Box>
          )
        } else {
          return (
            <ImageContainer>
              <>
                <video
                  ref={imageRef && imageRef}
                  //src={`data:image/png;base64, ${message.body}`}
                  src={blobUrl ? blobUrl : `data:video/webm;base64, ${message.body}`}
                  controls
                />
                {!downloaded && (
                  <div
                    className="absolute inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm rounded-lg transition-all duration-300 hover:bg-black/60 cursor-pointer group"
                    style={{ display: display }}
                    onClick={() => onClickDownload("video")}
                  >
                    <div className="flex flex-col items-center space-y-3 p-6">
                      <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center group-hover:bg-white/30 transition-all duration-300">
                        <Iconify
                          icon="solar:download-bold"
                          className="w-8 h-8 text-white group-hover:scale-110 transition-transform duration-300"
                        />
                      </div>
                      <div className="text-center">
                        <p className="text-white font-medium text-sm mb-1">{t('media.videoNotDownloaded')}</p>
                        <p className="text-white/80 text-xs">{t('media.clickToDownload')}</p>
                      </div>
                    </div>
                  </div>
                )}

              </>
            </ImageContainer>
          )
        }
      }

    } else if (mimeTypesImages.includes(message.mimetype)) {
      if (message.type === "revoked") {
        return (
          <Box>
            <Typography sx={{ mb: 2, fontSize: 12, fontStyle: 'italic' }}>{t('media.imageDeleted')}</Typography>
          </Box>
        )
      } else {
        return (
          isReply ? (
            <ImageContainerReply>
              <img
                style={{ borderRadius: 5, maxHeight: 100, width: '100%' }}
                ref={imageRef}
                src={blobUrl ? blobUrl : `data:image/png;base64, ${message.body}`}
                // loading={"lazy"}
                alt={message.caption}
                onClick={() => {

                  handleOnOpenModalImage()
                }}
              />

            </ImageContainerReply>
          ) : (
            <ImageContainer>
              {loadingDownload ? (
                <SkeletonChatImage />
              ) : (
                <>
                  <img
                    style={{ borderRadius: 5 }}
                    ref={imageRef}
                    src={blobUrl ? blobUrl : `data:image/png;base64, ${message.body}`}
                    // loading={"lazy"}
                    alt={message.caption}
                    onClick={() => {

                      handleOnOpenModalImage()
                    }}
                  />


                </>

              )}
            </ImageContainer>
          )

        )
      }

    }
  }

  function getBodyMessage() {
    // Early return for chat messages with a body
    if (message?.body && (message.type === "chat" || message.type === "automated_greeting_message")) {
      return <MarkdownWrapper>{message.body}</MarkdownWrapper>;
    } else if (message.type === "ciphertext") {
      return (
        <div className="bg-yellow-50 dark:bg-yellow-500/10 border border-yellow-100 dark:border-yellow-500/20 p-2 rounded-sm flex flex-row gap-2 items-center">
          <p className="text-sm text-muted-foreground italic">{t('messageList.waitingMessage')}</p>
          <Button
            onClick={() => {
              window.open('https://faq.whatsapp.com/835452491239734/?helpref=hc_fnav&locale=pt_BR', '_blank')
            }}
            variant="text"
            className="text-black dark:text-white h-5 underline"
          >
            {t('messageList.learnMore')}
          </Button>
        </div>
      )
    }

    // Group conditions for media messages
    const isMediaMessage = message.type === "location" || message.isMedia === false ||
      ['ptt', 'image', 'audio', 'video'].includes(message.type) ||
      message.mimetype === "image/jpeg";

    if (isMediaMessage) {
      return validaMediaMessage(message, isReply);
    }

    // Handle cases without a message body
    if (!message?.body) {
      return getReason(message);
    }
  }


  const LABEL_REPLY = t('messageList.actions.reply');
  const LABEL_FORWARD = t('messageList.actions.forward');
  const optionsPrelude = [

    {
      label: LABEL_REPLY,
      method() {
        setAnchorEl(null);
        selectMessageResponder();
      },
    },
  ];

  // Adiciona opção "Apagar" apenas para WhatsApp
  if (message.platform === 'whatsapp') {
    optionsPrelude.push({
      label: t('messageList.actions.delete'),
      method() {
        setAnchorEl(null);
        setOpenDeleteDialog(true);
      },
    });
    optionsPrelude.push({
      label: t('messageList.actions.select'),
      method() {
        setAnchorEl(null);
        selectMessageId(message.id);
      },
    });
  }

  const options = chat.statusRoom === "Atendendo" ? optionsPrelude : optionsPrelude.filter(option => option.label !== LABEL_FORWARD && option.label !== LABEL_REPLY);


  if (message.type === "video" || message.type === "image") {
    options.push({
      label: t('messageList.actions.downloadMedia'),
      method() {
        setAnchorEl(null);
        baixarMidiaDevice();
      },
    });
  }



  if (message.type === "ptt" || message.type === "audio") {
    options.push({
      label: t('messageList.actions.downloadAudio'),
      method() {
        setAnchorEl(null);
        baixarAudioDevice();
      },
    });
  }

  let gatilhosCopilot = config?.global.chatgpt_gatilhos;

  if (message.type === "note") {
    return (
      <Stack key={key} direction={'row'}>
        <ChatLayout side={isMe}>
          <Stack sx={{ mt: 3 }}>
            <div
              className={`
        ${isDesktop ? 'w-fit' : 'w-full'}
        text-sm max-w-full h-auto relative
        shadow-sm flex flex-col flex-wrap
         rounded-md
        min-w-[200px]
        bg-slate-50 dark:bg-[#222529]
      `}
            >
              <div className="w-full bg-yellow-100 dark:bg-yellow-500/20 rounded-t-sm flex flex-row justify-between px-1 min-h-6 items-center">
                <div className="flex flex-row gap-1 items-center">
                  <Iconify className="text-yellow-600 dark:text-yellow-400" icon="fluent:note-16-filled" />
                  <p className="text-violet-800 dark:text-violet-300 p-1 text-xs">{message.userName}</p>
                </div>

                <Button
                  onClick={onDeleteNote}
                  size="icon"
                  className="h-6 w-6"
                  variant="ghost"
                >
                  <Iconify color="red" icon="mi:delete" />
                </Button>

              </div>
              <div className="msg-title-top mb-2.5 pr-5 w-fit text-green-600 dark:text-green-400 font-bold">
                <div ref={textRef}>{message.body}</div>
              </div>

            </div>

            <Stack spacing={0.5} alignItems={"center"} direction={"row"}>

              {getMessageTime(message)}
            </Stack>
          </Stack>
        </ChatLayout>
      </Stack>
    )
  }

  if (message.ack === -1) {
    return (
      <div className="w-full flex justify-end mt-8">
        <div className="flex flex-row items-center gap-2 max-w-[800px]">
          <div className="flex flex-row gap-1">
            <Button
              size="icon"
              onClick={handleResendClick}
              variant="secondary"
              disabled={isButtonDisabled || loadingResend || loadingResendAudio}
            >
              {(loadingResend || loadingResendAudio) ? (
                <Iconify icon="line-md:loading-twotone-loop" className="text-violet-600" />
              ) : (
                <Iconify icon="stash:arrow-retry" className="text-[30px]" />
              )}
            </Button>

            <Button
              size="icon"
              onClick={() => onDeleteMsgAudioResend(message)}
              variant="secondary"
            >
              <Iconify icon="material-symbols:delete" className="text-[18px]" />
            </Button>
          </div>

          <Card className="flex flex-col p-2 bg-red-50 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20">
            {(message.type === 'audio' || message.type === 'ptt') ? (
              <div>
                <AudioComponent
                  downloaded={true}
                  url={audioUrl}
                  loading={false}
                  isMe={message.fromMe}
                  profileImage={!message?.sender?.profilePicThumbObj?.eurl ? defaultImage : message?.sender?.profilePicThumbObj?.eurl}
                  audioRef={audioRef}
                  id={message.id}
                  getAudioFromCache={getAudioFromCache}
                />
              </div>
            ) : message.template ? (
              <div className="flex relative py-4 whitespace-pre-wrap text-[14px]">
                <TemplateMessage
                  template={message.template}
                  isMe={isMe}
                  positions={message?.template?.positions || []}
                />
              </div>
            ) : (
              <div className="flex relative py-4 whitespace-pre-wrap text-[14px]" isWarning={isWarning}>
                <div ref={textRef}>{getBodyMessage()}</div>
              </div>
            )}
            {getMessageTime(message)}
            {message.errorMessage && (
              <div className="flex items-start gap-1.5 mt-1 px-1 py-1 bg-red-100 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20 rounded text-xs text-red-700 dark:text-red-400">
                <Iconify icon="solar:danger-triangle-bold" className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                <div>
                  <span className="font-medium">{t('common:status.error')} {message.errorMessage.code}: </span>
                  <span>{message.errorMessage.message}</span>
                </div>
              </div>
            )}
          </Card>


        </div>

      </div>

    )
  }

  return (
    <Stack key={key} direction={'row'}>
      <ChatLayout side={isMe}>

        <Stack sx={{ mt: 3 }}>
          <div className={`flex items-start gap-1 ${isMe === 'left' ? 'flex-row' : 'flex-row-reverse'} group`}>
            <Tooltip
              title={message.fromMe === false ? getSenderDisplayName() : ''}
              placement="top"
              arrow
            >
            <div
              className={`${isDesktop ? 'w-fit' : 'w-full'} text-xs max-w-full h-auto relative shadow-sm flex flex-col flex-wrap rounded-lg min-w-[100px] text-gray-800 dark:text-[#D1D2D3] ${isWarning ? 'w-full text-center' : ''} ${isWarning ? '' : (isMe === "left" ? 'bg-white dark:bg-[#222529] rounded-tl-none' : 'bg-[#d9fdd3] dark:bg-[#005C4B] rounded-tr-none')} ${isWarning ? '' : 'shadow-sm dark:shadow-none'} p-1.5`}
            >
              <MessageContent sx={{ elevation: 0 }} side={isMe} isWarning={isWarning}>
                {message.type === "document" ? (
                  message.preSend ? (
                    <div className="w-[200px] h-[100px] flex items-center justify-center bg-muted/20 rounded-lg border border-border/50 backdrop-blur-sm">
                      <div className="flex flex-col items-center space-y-3">
                        <div className="flex items-center space-x-2">
                          <Iconify icon="solar:document-bold" className="w-4 h-4 text-primary animate-pulse" />
                          <p className="text-xs italic text-muted-foreground">{t('media.sendingDocument')}</p>
                        </div>
                        <div className="w-32">
                          <Progress value={progressValue} className="h-2" />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <Card
                      className={`
                        w-full max-w-sm cursor-pointer transition-all duration-200 hover:shadow-md
                        ${isMe ? 'bg-primary/5 border-primary/20' : 'bg-background border-border'}
                        ${isWarning ? 'max-w-lg' : ''}
                      `}
                      onClick={() =>
                        onClickDownload("document", {
                          mimetype: message.mimetype,
                          filename: message.filename,
                          mediadata: message.mediadata,
                        })
                      }
                    >
                      <CardContent className="p-4">
                        <div className="flex items-center justify-between gap-3">
                          <div className="flex items-center gap-3 flex-1 min-w-0">
                            <div className="flex-shrink-0">
                              <Iconify
                                icon="solar:document-bold"
                                className="w-8 h-8 text-primary"
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              <div
                                className="text-sm text-foreground truncate"
                              >
                                {message.filename}
                              </div>

                            </div>
                          </div>
                          <div className="flex-shrink-0">
                            {loadingDownload ? (
                              <div className="w-8 h-8 bg-primary rounded-full animate-spin border-2 border-primary/20 flex items-center justify-center">
                                <div className="w-3 h-3 bg-white rounded-full"></div>
                              </div>
                            ) : (
                              <ButtonLoading
                                variant="ghost"
                                size="icon"
                                className="w-8 h-8 hover:bg-primary/10"
                              >
                                <Iconify
                                  icon="solar:download-bold"
                                  className="w-4 h-4 text-primary"
                                />
                              </ButtonLoading>
                            )}
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  )
                ) : message.type === "vcard" ? (
                  <MessageContentText >
                    <Vcard
                      message={message}
                    />
                  </MessageContentText>
                ) : message.type === "multi_vcard" ? (
                  <MessageContentText >
                    <ModalMultiContact
                      message={message}
                    />

                  </MessageContentText>
                ) : message.type === "e2e_notification" ? (
                  <MessageContentText >
                    <Alert variant="outlined" severity="info">{t('messageList.encryptionMessage')}</Alert>
                  </MessageContentText>
                ) : message.type === "notification_template" ? (
                  <MessageContentText >
                    <Alert variant="outlined" severity="info">{t('messageList.whatsappMessage')}</Alert>
                  </MessageContentText>
                ) : message.type === "protocol" ? (
                  <MessageContentText >
                    <Alert variant="outlined" severity="info">{t('messageList.whatsappMessage')}</Alert>
                  </MessageContentText>
                ) : message.type === "call_log" ? (
                  <MessageContentText >
                    <Alert variant="outlined" severity="error">{t('messageList.missedCall')}</Alert>
                  </MessageContentText>
                ) : message.template ? (
                  <MessageContentText >
                    <TemplateMessage
                      template={message.template}
                      isMe={isMe}
                      positions={message?.template?.positions || []}
                    />
                  </MessageContentText>
                ) : (
                  <MessageContentText isWarning={isWarning}>
                    {!!message.quotedMsg && <QuotedMessage message={message} />}
                    <div ref={textRef}>{getBodyMessage()}</div>
                  </MessageContentText>
                )}
              </MessageContent>

              {message.caption && <span className="caption bottom-0 p-2.5">{message.caption}</span>}

            </div>
            </Tooltip>

            {!isReply && (
              <div className="opacity-0 group-hover:opacity-100 transition-all duration-200 ease-in-out self-center scale-75 group-hover:scale-100 px-1">
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      className="w-8 h-8 rounded-full bg-white dark:bg-[#222529] shadow-md hover:shadow-lg dark:shadow-none border border-gray-100 dark:border-[#383838] text-gray-700 dark:text-[#D1D2D3] hover:bg-gray-50 dark:hover:bg-[#2a2d31] transition-all"
                      size="icon"
                    >
                      <Iconify icon="tabler:dots-vertical" className="w-5 h-5" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="w-48" align={isMe === 'left' ? 'start' : 'end'}>
                    {!typesIgnore.includes(message.type) && options.map((option) => (
                      <DropdownMenuItem key={option.label} onClick={() => option.method()}>
                        {option.label}
                      </DropdownMenuItem>
                    ))}

                    {message.type === "chat" && verifyRules(user.rules, 'chatgpt') && (
                      <>
                        <Divider />
                        <DropdownMenuSub>
                          <DropdownMenuSubTrigger>Copilot</DropdownMenuSubTrigger>
                          <DropdownMenuPortal>
                            <DropdownMenuSubContent className="w-[300px] mb-16">
                              <Scrollbar>
                                {gatilhosCopilot?.length > 0 && gatilhosCopilot.map(gatilho => {
                                  return (
                                    <DropdownMenuItem
                                      key={gatilho.nome}
                                      onClick={() => {
                                        let data = {
                                          message: message.body,
                                          input: gatilho.input
                                        }

                                        callbackGpt(data);
                                        handleCloseMenu()
                                        handleClose();

                                      }}>
                                      <Stack alignItems={"center"} spacing={1} direction={"row"}>
                                        {gatilho.nome}
                                      </Stack>

                                    </DropdownMenuItem>
                                  )
                                })}
                              </Scrollbar>
                            </DropdownMenuSubContent>
                          </DropdownMenuPortal>
                        </DropdownMenuSub>
                      </>
                    )}
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            )}
          </div>
          <Stack spacing={0.5} alignItems={"center"} direction={"row"} justifyContent={isMe === 'right' ? 'flex-end' : 'flex-start'}>
            {message.isDeleted && (
              <Tooltip title={t('messageList.messageDeleted')}>
                <IconButton disable>
                  <Iconify width={18} icon="material-symbols:delete" color="red" />
                </IconButton>
              </Tooltip>

            )}
            {getMessageTime(message)}
            {message.errorMessage && (
              <div className="flex items-start gap-1.5 mt-1 px-1 py-1 bg-red-100 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20 rounded text-xs text-red-700 dark:text-red-400 max-w-[400px]">
                <Iconify icon="solar:danger-triangle-bold" className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                <div>
                  <span className="font-medium">{t('common:status.error')} {message.errorMessage.code}: </span>
                  <span>{message.errorMessage.message}</span>
                </div>
              </div>
            )}
          </Stack>
        </Stack>


        {openDeleteDialog && (
          <AlertDialogLoading
            loading={loadingDeletarMensagem}
            title={t('messageList.confirmDeleteTitle')}
            content={t('messageList.confirmDeleteContent')}
            confirm={async () => {
              try {
                setLoadingDeletarMensagem(true);
                await excluirMensagem(message);
              } catch (error) {
                enqueueSnackbar(t('messageList.deleteFailed'), { variant: 'error' });

              } finally {
                setOpenDeleteDialog(false);
                setLoadingDeletarMensagem(false);
              }
            }}
            close={() => setOpenDeleteDialog(false)}
          />
        )}

        {openEncaminharDialog && (
          <ModalEncaminharMsg
            user={user}
            open={openEncaminharDialog}
            loading={loadingEncaminharMensagem}
            onSubmit={data => {
              encaminharMesagemWhatsapp(data);
            }}
            onClose={() => setOpenEncaminharDialog(false)}
          />
        )}
      </ChatLayout>
    </Stack>

  );
};

ChatComponent.propTypes = {
  message: PropTypes.any.isRequired,
  session: PropTypes.string.isRequired,
  isMe: PropTypes.string.isRequired,
};

export default ChatComponent;
